import { useFormContext } from 'react-hook-form';
import { Chip } from 'shared/mui/Chips';
import { useAnchor } from 'shared/mui/DatePicker/hooks/useAnchor';
import { useFilterContext } from 'shared/mui/Filter/context/filterContext';
import { FilterChipLabel } from 'shared/mui/Filter/FilterChipsToolbar/FilterChips/components/FilterChipLabel/FilterChipLabel';
import { PopoverChip } from 'shared/mui/Filter/FilterChipsToolbar/FilterChips/components/PopoverChip/PopoverChip';

export type FilterSelectChoicesChipProps = {
  label: string;
  choices?: { id: any; label: string }[];
  name: string;
  children: React.ReactNode;
  onDelete?: VoidFunction;
  onApply?: VoidFunction;
  onReset?: VoidFunction;
};

export const FilterSelectChoicesChip: React.FC<FilterSelectChoicesChipProps> = ({
  choices,
  name,
  label,
  onApply,
  children,
  onDelete,
  onReset,
}) => {
  const { getValues, setValue } = useFormContext();
  const { setAppliedFilter, appliedFilters } = useFilterContext();
  const { handleClose, handleClick, anchorEl } = useAnchor<HTMLDivElement>();

  if (typeof appliedFilters[name] !== 'boolean' && !appliedFilters[name]) {
    return <></>;
  }

  function onApplyHandler() {
    handleClose();
    onApply && onApply();
    setAppliedFilter(name, getValues(name));
  }

  function onResetHandler() {
    onReset && onReset();
    setAppliedFilter(name, appliedFilters?.[name]);
    setValue(name, appliedFilters?.[name]);
  }
  const open = Boolean(anchorEl);

  return (
    <>
      <PopoverChip
        anchorEl={anchorEl}
        onApply={onApplyHandler}
        onClose={handleClose}
        onReset={onResetHandler}
        open={open}
      >
        {children}
      </PopoverChip>
      <Chip
        label={
          <FilterChipLabel
            label={label}
            value={choices?.find((choice) => choice.id === appliedFilters?.[name])?.label}
          />
        }
        onClick={handleClick}
        onDelete={() => {
          onDelete && onDelete();
          setValue(name, null);
          setAppliedFilter(name, null);
        }}
        size="medium"
      />
    </>
  );
};
